export default {
  disponibileBio: 'Available in Bio',
  certificatoBio: 'Certified Bio',
  'Certificato Bio': 'Certified Bio',
  'Disponibile Bio': 'Available in Bio',
  vino: 'Wine',
  birra: 'Beer',
  panificati: 'Bakery Products',
  agricoltura: 'Agriculture',
  nutraceutica: 'Nutraceutical',
  altriProdotti: 'Other products of the same family',
  structuredTitle: 'Increase the effectiveness of {title} with:',
  prefix: {
    vino: 'Wines',
  },
  adattoPer: 'Suitable for',
  stili: 'Styles',
  disponibilitaProdotto: 'Available in formats: ',
}
